module.exports = "<div class=\"title\">\n  <i class=\"ico {{ico}} mt2 mr10\" [hidden]=\"!ico\"></i>\n  <h3 class=\"dib vat\">{{title}}</h3>\n  <ng-content></ng-content>\n</div>\n<hr class=\"separator\">\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/modal/modal-title.component.html
// module id = J4Ow
// module chunks = 6